let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7UY71")).then(() => parcelRequire('imnD1'));